import { NgModule, ModuleWithProviders, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectComponent } from './multiselect.component';
import { ClickOutsideDirective } from './click-outside.directive';
import { ListFilterPipe } from './list-filter.pipe';
import { SortDataPipe } from './sort-data.pipe';
import { InputSearchComponent } from './input-search/input-search.component'
import { TranslateModule } from '../../pipes/translate.module';
import { AutofocusDirective } from './autofocus.directive';
import { FocusDirective } from '../../directive/focus.directive';
import { PopoverModule, PopoverDirective } from 'ngx-bootstrap/popover';
import { FlagsComponent } from '../flags/flags.component';
import { AppService } from '../../shared/services/app.service';

@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule,PopoverModule],
  declarations: [MultiSelectComponent, ClickOutsideDirective, ListFilterPipe, SortDataPipe,InputSearchComponent, AutofocusDirective,FocusDirective,FlagsComponent],
  exports: [MultiSelectComponent, InputSearchComponent,FocusDirective,PopoverDirective,FlagsComponent]
})

export class NgMultiSelectDropDownModule {
  public entryComponents: any = [
    MultiSelectComponent
  ]
    static forRoot(): ModuleWithProviders<NgMultiSelectDropDownModule> {
      return {
        ngModule: NgMultiSelectDropDownModule
      };
    }
    public appService: AppService;
    constructor(public injector: Injector) {
      this.appService = injector.get(AppService);
      this.appService._factories["modules"]["NgMultiSelectDropDownModule"] = this.entryComponents;
      if (this.entryComponents && this.entryComponents.length) {
        this.appService.buildFactory(this.entryComponents);
      }
    }
}
